// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--65ed3";
export var arrow = "Accordion-module--arrow--630b2";
export var arrowOpen = "Accordion-module--arrowOpen--263d7";
export var contentInner = "Accordion-module--contentInner--5c351";
export var contentText = "Accordion-module--contentText--65da5";
export var expanded = "Accordion-module--expanded--5729a";
export var placeholder = "Accordion-module--placeholder--ea327";
export var tab = "Accordion-module--tab--a6421";
export var tabContent = "Accordion-module--tabContent--871df";
export var tabLabel = "Accordion-module--tabLabel--2fb16";
export var wrapper = "Accordion-module--wrapper--91a2d";